document.addEventListener('DOMContentLoaded', function () {

  const youtubeSections = document.querySelectorAll(
    '[data-youtube-url]'
  );

  youtubeSections.forEach(function (section) {

    const url = section.getAttribute('data-youtube-url');

    if (!url) return;

    let videoId = '';

    try {

      const parsedUrl = new URL(url);

      /*
       * Standard YouTube URL
       * youtube.com/watch?v=XXXX
       */
      if (
        parsedUrl.hostname.includes('youtube.com') &&
        parsedUrl.searchParams.get('v')
      ) {
        videoId = parsedUrl.searchParams.get('v');
      }

      /*
       * YouTube Shorts
       * youtube.com/shorts/XXXX
       */
      else if (
        parsedUrl.hostname.includes('youtube.com') &&
        parsedUrl.pathname.includes('/shorts/')
      ) {
        videoId = parsedUrl.pathname
          .split('/shorts/')[1]
          .split('/')[0];
      }

      /*
       * YouTube embed URL
       */
      else if (
        parsedUrl.hostname.includes('youtube.com') &&
        parsedUrl.pathname.includes('/embed/')
      ) {
        videoId = parsedUrl.pathname
          .split('/embed/')[1]
          .split('/')[0];
      }

      /*
       * youtu.be/XXXX
       */
      else if (
        parsedUrl.hostname === 'youtu.be'
      ) {
        videoId = parsedUrl.pathname
          .replace('/', '')
          .split('/')[0];
      }

    } catch (error) {

      console.warn(
        'Invalid YouTube URL:',
        url
      );

    }

    if (!videoId) {

      section.querySelector(
        '.product-video-section__youtube'
      ).innerHTML =
        '<p>Invalid YouTube video URL.</p>';

      return;

    }

    const container = section.querySelector(
      '.product-video-section__youtube'
    );

    container.innerHTML = '';

    const iframe = document.createElement('iframe');

    iframe.src =
      'https://www.youtube.com/embed/' +
      encodeURIComponent(videoId) +
      '?rel=0';

    iframe.title = 'Product Video';

    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );

    iframe.setAttribute(
      'allowfullscreen',
      ''
    );

    iframe.loading = 'lazy';

    iframe.className =
      'product-video-section__iframe';

    container.appendChild(iframe);

  });

});